<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex md12>
                <v-card>

                  <v-toolbar card color="white">
                    <v-toolbar-title>Horario</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="downloadTimetable" v-if="firmado">
                      <v-icon left>cloud_download</v-icon>
                      Descargar
                    </v-btn>
                  </v-toolbar>

                    <v-card-text>
                      <v-alert
                        :value="true"
                        color="error"
                        icon="warning"
                        outline
                        v-if="!firmado"
                      >
                          Este horario será válido hasta que se haya firmado de forma digital.
                      </v-alert>
                        <v-data-table
                                :headers="headers"
                                :items="horario"
                                hide-actions
                                v-if="$mq !== 'sm'"
                        >
                            <template slot="items" slot-scope="props">
                                <td>
                                    <strong>{{props.item.materia.nombre}}</strong><br>
                                    {{props.item.materia.clave}}<br>
                                    {{props.item.materia.docente}}<br>
                                </td>
                                <td>{{props.item.materia.grupo}}</td>
                                <td>{{props.item.materia.creditos}}</td>
                                <td v-html="props.item.materia.horario[2]"></td>
                                <td v-html="props.item.materia.horario[3]"></td>
                                <td v-html="props.item.materia.horario[4]"></td>
                                <td v-html="props.item.materia.horario[5]"></td>
                                <td v-html="props.item.materia.horario[6]"></td>
                                <td v-html="props.item.materia.horario[7]"></td>
                                <td v-html="props.item.materia.horario[1]"></td>
                            </template>
                        </v-data-table>
                        <v-data-iterator
                                :items="horario"
                                :rows-per-page-items="[]"
                                content-tag="v-layout"
                                row
                                wrap
                                v-else-if="$mq === 'sm'"
                                hide-actions
                        >
                            <v-flex
                                    slot="item"
                                    slot-scope="props"
                                    xs12
                                    sm6
                                    md4
                                    lg3
                            >
                                <v-card>
                                    <v-card-title primary-title>
                                        <div>
                                            <h4>{{ props.item.materia.nombre }}</h4>
                                            <div>{{ props.item.materia.clave}}</div>
                                            <div>{{ props.item.materia.docente}}</div>
                                        </div>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-list dense>
                                        <v-list-tile>
                                            <v-list-tile-content>Grupo:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.materia.grupo }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>Creditos:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.materia.creditos }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[2]">
                                            <v-list-tile-content>Lunes:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[2]"></v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[3]">
                                            <v-list-tile-content>Martes:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[3] "></v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[4]">
                                            <v-list-tile-content>Miércoles:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[4] "></v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[5]">
                                            <v-list-tile-content>Jueves:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[5] "></v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[6]">
                                            <v-list-tile-content>Viernes:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[6] "></v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[7]">
                                            <v-list-tile-content>Sábado:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[7] "></v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.materia.horario[1]">
                                            <v-list-tile-content>Domingo:</v-list-tile-content>
                                            <v-list-tile-content class="align-end" v-html="props.item.materia.horario[1] "></v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-data-iterator>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="280px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando horario de clases</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import * as fileSaver from 'file-saver'

  export default {
    name: 'HorarioPage',
    mounted () {
      this.getHorario()
    },
    data: () => ({
      cargandoDatos: true,
      headers: [
        {
          text: 'Materia',
          align: 'left',
          value: 'materia'
        },
        { text: 'Gpo', value: 'grupo' },
        { text: 'Cr', value: 'creditos' },
        { text: 'Lunes', value: 'lunes' },
        { text: 'Martes', value: 'martes' },
        { text: 'Miércoles', value: 'miercoles' },
        { text: 'Jueves', value: 'jueves' },
        { text: 'Viernes', value: 'viernes' },
        { text: 'Sábado', value: 'sabado' },
        { text: 'Domingo', value: 'domingo' }
      ],
      horario: [],
      firmado: false
    }),
    methods: {
      getHorario () {
        axios.get('alumno/horario')
          .then(request => {
            this.cargandoDatos = false
            this.horario = request.data.horario
            this.firmado = request.data.firmado
          })
      },
      downloadTimetable () {
        axios.get('alumno/horario/download', {responseType: 'arraybuffer'})
          .then(response => {
            this.generandoPdf = false
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, 'horario.pdf')
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/information/HorarioPage.vue